import React from 'react';
import PropTypes from 'prop-types';
import {removeCookie, setCookie, isEqualId, formatId} from "../utilities";

const BodyTypeSelector = ({
                            bodyTypeInfo,
                            currentBodyTypeId,
                            changeBodyType,
                          }) => {
  return (
    <div className="ExteriorView__body-type-selector">
      <ul className="ExteriorView__body-type-selector__list">
        {bodyTypeInfo.map((bodyType, index) => {
          return (
            <li key={index}>
              <a
                // className={'ExteriorView__body-type-selector__link' + ((currentBodyTypeId === bodyType.carId) ? ' current': '')}
                className={'ExteriorView__body-type-selector__link' + (isEqualId(currentBodyTypeId, bodyType.carId) ? ' current': '')}
                href="javascript:void(0)"
                onClick={(e) => {
                  e.preventDefault();
                  if (changeBodyType) {
                    changeBodyType(bodyType.carId);
                    
                    // ブロックのCookieに保存
                    setCookie('mj_360bt', formatId(bodyType.carId));
                    removeCookie('mj_360gr');
  
                  }
                }}
              >
                {bodyType.tabName}
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
};
BodyTypeSelector.propTypes = {
  bodyTypeInfo: PropTypes.arrayOf(
    PropTypes.shape({
      model: PropTypes.string,
      tabName: PropTypes.string,
    }),
  ),
  currentBodyTypeId: PropTypes.string,
  changeBodyType: PropTypes.func,
};
BodyTypeSelector.defaultProps = {
  bodyTypeInfo: null,
  currentBodyTypeId: null,
  changeBodyType: null,
};

export default BodyTypeSelector;



// WEBPACK FOOTER //
// ./src/containers/exterior-view/BodyTypeSelector.jsx